// extracted by mini-css-extract-plugin
export default {"root":"AddPhysicianModal_root__ZsN9-","buttonGroup":"AddPhysicianModal_buttonGroup__pOTR4","modalHeader":"AddPhysicianModal_modalHeader__9aCvL"};